var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34.673,
    viewBox: "0 0 35 34.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-273 -2468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.148,0V30.149c0,4.139-2.081,4.5-2.618,4.524H33.238a3.181,3.181,0,0,0,3.176-3.179V.022Zm6.621,9.412h15.5a1.091,1.091,0,0,1,0,2.182h-15.5a1.091,1.091,0,0,1,0-2.182ZM24.7,24.33H13.55a1.091,1.091,0,0,1,0-2.182H24.7a1.091,1.091,0,0,1,0,2.182Zm0-4.866H13.55a1.091,1.091,0,0,1,0-2.182H24.7a1.091,1.091,0,0,1,0,2.182ZM31.65,24.33H28.822a1.091,1.091,0,0,1,0-2.182H31.65a1.091,1.091,0,0,1,0,2.182Zm0-4.866H28.822a1.091,1.091,0,0,1,0-2.182H31.65a1.091,1.091,0,0,1,0,2.182Z",
    transform: "translate(271.586 2468)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.793,28.21v9.676c0,3.141-1.585,3.416-1.987,3.431H2.062A2.062,2.062,0,0,1,0,39.256V28.18Z",
    transform: "translate(273 2459.986)",
    fill: "#0533b3",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.5ec49aa1baca2fa113a2b2d14ab947ae.svg";
export { ForwardRef as ReactComponent };